import MoreActionsButton from './MoreActionsButton';
import MoreActionsButtonContainer from './MoreActionsButton.container';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import MoreActionsButtonNew from '../MoreActionsButton.studio_gallery';
import React from 'react';
const ApiConversion = ({ deviation, className, iconSizeOverride, afterActionUrl, studioOrdering })=>{
    return /*#__PURE__*/ React.createElement(MoreActionsButtonNew, {
        deviation: deviation,
        size: iconSizeOverride !== null && iconSizeOverride !== void 0 ? iconSizeOverride : 'medium',
        afterActionUrl: afterActionUrl,
        studioOrdering: studioOrdering,
        className: className
    });
};
export default withFeatureBranch({
    studio_gallery: ApiConversion
})(MoreActionsButtonContainer(MoreActionsButton));

//# sourceMappingURL=index.js.map